module.exports = __webpack_public_path__ + "images/emoji/ru.1cea554cbb63841bb672.png";